import { useEffect } from "react";

import { LoginAnalyticsPageView } from "@/constants/analytics/Login";
import { LoginTestID } from "@/constants/TestID";
import { useAnalytics } from "@/services/Analytics";
import LoginScreenContainer from "@/ui/components/authentication/LoginScreenContainer";
import MultiFactorAuthForm from "@/ui/components/authentication/MultiFactorAuthForm";
import AppVersionLabel from "@/ui/components/common/AppVersionLabel";

const Screen = () => {
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    trackPageView(LoginAnalyticsPageView.MFA);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoginScreenContainer testID={LoginTestID.ForgotPassword}>
      <MultiFactorAuthForm />
      <AppVersionLabel testID={LoginTestID.MFA} />
    </LoginScreenContainer>
  );
};

// eslint-disable-next-line import-x/no-unused-modules -- File is used by expo-router file based navigation but TypeScript can not infer its usage
export default Screen;
